import { pushToDataLayerSitechromeWrapper as pushToDataLayer } from "@asosteam/asos-web-datalayer";
import { noticeError } from "@src/helpers/monitoring";

const SEPARATOR = ":";

// Mixpanel splits each experiments entry on ":", so the datalayer schema
// (^[^:]+:[^:]+$) rejects empty keys and keys containing the separator.
const isValidKeyPart = value =>
  typeof value === "string" && value !== "" && !value.includes(SEPARATOR);

export const triggerExperimentEvent = (key, variation) => {
  if (typeof key !== "string") {
    return;
  }

  const variationKey =
    typeof variation === "number" ? String(variation) : variation;

  if (!isValidKeyPart(key) || !isValidKeyPart(variationKey)) {
    noticeError(
      new Error(
        `experiment_started not sent: invalid experiment or variation key "${key}${SEPARATOR}${variationKey}"`
      )
    );
    return;
  }

  pushToDataLayer({
    experiment_started: {
      experiments: [`${key}${SEPARATOR}${variationKey}`]
    }
  });
};
